import { Autocomplete, TextField } from '@mui/material';
import { useFetch } from '../../../../hooks/useFecth';

export default function SelectClubs({ onChange, name, value, disabled = false, club = null }) {
    const { data, isFetching } = useFetch('migration/clubs');

    const selected = data?.find(item => Number(value) === item.numg_clube) ||
        (club && value ? { numg_clube: Number(value), sigl_clube: club.sigl_clube || club.name || '' } : null);

    return (
        <Autocomplete
            placeholder="Selecione um clube"
            getOptionLabel={e => e?.sigl_clube || null}
            options={data || []}
            value={selected || null}
            name={name}
            disabled={disabled}
            loading={isFetching}
            onChange={(e, newValue) => onChange(name, newValue?.numg_clube)}
            renderInput={params => <TextField {...params} label="Selecione um clube" />}
        />
    );
}
